import React from 'react';
import { AdvantagesData } from './AdvantagesData';
import styled from 'styled-components';
import { Advantage } from '../../components';

const Advantages = () => {
  return (
    <AdvantagesBlock>
      {AdvantagesData.map(({ img, subtitle, title }, index) => (
        <Advantage key={index} img={img} subtitle={subtitle} title={title} />
      ))}
    </AdvantagesBlock>
  );
};

const AdvantagesBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 57px;
  justify-content: space-between;
  gap: 35px;
  margin-bottom: -30px;
  @media (max-width: 1135px) {
    margin-bottom: -62px;
  }
  @media (max-width: 599px) {
    gap: 28px;
    margin-bottom: -33px;
  }
`;

export default Advantages;
